import { render, staticRenderFns } from "./ProjectSuperLite.vue?vue&type=template&id=174507b9&scoped=true&"
import script from "./ProjectSuperLite.vue?vue&type=script&lang=js&"
export * from "./ProjectSuperLite.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSuperLite.vue?vue&type=style&index=0&id=174507b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174507b9",
  null
  
)

export default component.exports